// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BBf","block":"BBd7"};